import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const books = [{
  number: 1,
  title: 'รากฐานฟุตบอล',
  promise: 'สร้างพื้นฐานที่แข็งแกร่งให้นักเรียนทุกคน ด้วยแผนการสอนระดับเริ่มต้นที่พร้อมใช้ทันที'
}, {
  number: 2,
  title: 'การควบคุมและความคล่องตัว',
  promise: 'แบบฝึกหัดเฉพาะทางพร้อมไดอะแกรมสนาม ที่ช่วยพัฒนาทักษะนักเรียนอย่างเป็นระบบ'
}, {
  number: 3,
  title: 'การส่งบอลและการทำงานเป็นทีม',
  promise: 'แผนการสอนทีมเวิร์คที่ใช้งานได้จริง พร้อมเกมและกิจกรรมสำหรับทุกขนาดกลุ่ม'
}, {
  number: 4,
  title: 'ยุทธวิธีเบื้องต้น',
  promise: 'สอนยุทธวิธีฟุตบอลได้อย่างมืออาชีพ ด้วยไดอะแกรมและแผนการสอนที่ชัดเจน'
}, {
  number: 5,
  title: 'ผลงานและความเข้มข้น',
  promise: 'ยกระดับนักเรียนสู่การแข่งขัน ด้วยโปรแกรมฝึกซ้อมเข้มข้นที่วางแผนมาแล้ว'
}, {
  number: 6,
  title: 'ปฏิทินการฝึกซ้อมตลอดปี',
  promise: 'ระบบการวางแผนทั้งปีสำหรับโค้ช ครอบคลุมทุกระดับ ทุกเดือน ทุกสัปดาห์'
}];
export function SixBooks() {
  return <section className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-209">
      <div className="max-w-6xl mx-auto" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-211">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-3 md:mb-4" data-id="element-212">
            6 เล่มของระบบครบชุด
          </h2>
          <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-213">
            เครื่องมือดิจิทัลในรูปแบบ PDF
            พร้อมพิมพ์หรือดูบนแท็บเล็ตของคุณตั้งแต่วันนี้
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-214">
          {books.map((book, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} whileHover={{
          y: -6
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg flex flex-col h-full border-l-4 border-gold-accent" data-id="element-215">
              <div className="bg-navy-dark p-5 md:p-6 relative" data-id="element-216">
                <div className="absolute top-4 right-4 w-10 h-10 md:w-12 md:h-12 bg-gold-accent/20 rounded-full flex items-center justify-center border border-gold-accent/30" data-id="element-217">
                  <span className="text-xl md:text-2xl font-bold text-gold-accent" data-id="element-218">
                    {book.number}
                  </span>
                </div>
                <BookOpen className="w-8 h-8 md:w-10 md:h-10 text-gold-accent mb-3 md:mb-4" data-id="element-219" />
                <h3 className="text-lg md:text-xl font-display font-bold text-white" data-id="element-220">
                  เล่มที่ {book.number}
                </h3>
              </div>
              <div className="p-5 md:p-6 flex-grow flex flex-col" data-id="element-221">
                <h4 className="text-base md:text-lg font-bold text-navy-primary mb-2 md:mb-3" data-id="element-222">
                  {book.title}
                </h4>
                <p className="text-sm md:text-base text-gray-700 leading-relaxed flex-grow" data-id="element-223">
                  {book.promise}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}